export enum BillFor {
  BUSINESS = 'Business',

  PATIENT = 'Patient',
}
